import { Tooltip } from "@mui/material"
import moment from "moment"
// import { useSelector } from "react-redux"
import { Link } from "react-router-dom"

export const ModeGantt = (props) => {

    // const { usuariosTarea } = useSelector(state => state.general)
    const { hitosList: taskList, blocksList: blocks = [], handleEditTask } = props
    // console.log({ taskList })
    // console.log({ blocks })

    return (
        <div className="table-responsive animate__animated animate__fadeIn p-mode-gantt">
            <table className="table table-sm ms-2 p-table-tasks table-bordered table-hover">
                <thead>
                    <tr className="text-center" key={888}>
                        <th scope="col" colSpan={4} rowSpan={3}>
                            <div className="d-flex justify-content-center align-items-start" style={{ marginTop: '-30px' }}>
                                Tareas
                            </div>
                        </th>
                        {blocks?.map(b => (
                            <th scope="col" colSpan={7} key={b.id}>{b.name}</th>
                        ))}
                    </tr>
                    <tr className="text-center" key={999}>
                        {blocks[0]?.days.map((day, index) => (
                            <th scope="col" className={`wcol ${day === moment(new Date()).format('DD') ? 'current-day-task' : ''}`} key={index}>{day}</th>
                        ))}

                        {blocks[1]?.days.map((day, index) => (
                            <th scope="col" className={`wcol ${day === moment(new Date()).format('DD') ? 'current-day-task' : ''}`} key={index}>{day}</th>
                        ))}

                        {blocks[2]?.days.map((day, index) => (
                            <th scope="col" className={`wcol ${day === moment(new Date()).format('DD') ? 'current-day-task' : ''}`} key={index}>{day}</th>
                        ))}

                        {blocks[3]?.days.map((day, index) => (
                            <th scope="col" className={`wcol ${day === moment(new Date()).format('DD') ? 'current-day-task' : ''}`} key={index}>{day}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {taskList?.map((it, index) => (
                        <tr key={index}>
                            <td colSpan={4}>
                                <Link to="" onClick={() => handleEditTask(it)} className="text-start">
                                    <div className="d-flex justify-content-start align-items-center">
                                        {/* <span className='punto-hito' style={{ backgroundColor: it?.color }}></span> */}
                                        <div
                                            className="text-center"
                                            style={{
                                                fontSize: '10px',
                                                verticalAlign: 'middle'
                                            }}>
                                            {it.orden})
                                        </div>
                                        <Tooltip title={it.nombre} placement="right">
                                            <span className="name-task ms-2">
                                                {/* {it?.nombre?.length > 38 ?
                                                    `${it?.nombre?.substring(0, 38)}...`
                                                    :
                                                    it?.nombre
                                                } */}
                                                { it?.nombre}
                                            </span>
                                        </Tooltip>
                                    </div>
                                </Link>
                            </td>
                            <Block it={it} show={it.block === 1} />
                            <Block it={it} show={it.block === 2} />
                            <Block it={it} show={it.block === 3} />
                            <Block it={it} show={it.block === 4} />
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    )
}

const Block = ({ it, show }) => {
    return (
        <>
            <td>
                {(show && it.day_ini === 1) ?
                    <TaskBar it={it} /> : ''
                }
            </td>
            <td>
                {(show && it.day_ini === 2) ?
                    <TaskBar it={it} /> : ''
                }
            </td>
            <td>
                {(show && it.day_ini === 3) ?
                    <TaskBar it={it} /> : ''
                }
            </td>
            <td>
                {(show && it.day_ini === 4) ?
                    <TaskBar it={it} /> : ''
                }
            </td>
            <td>
                {(show && it.day_ini === 5) ?
                    <TaskBar it={it} /> : ''
                }
            </td>
            <td>
                {(show && it.day_ini === 6) ?
                    <TaskBar it={it} /> : ''
                }
            </td>
            <td>
                {(show && it.day_ini === 7) ?
                    <TaskBar it={it} /> : ''
                }
            </td>
        </>
    )
}

const TaskBar = ({ it }) => {
    const { days, color } = it

    return (
        <div
            className={`task-bar name-task`}
            style={{ width: `${days * 3}%`, height: '20px', backgroundColor: color }}
        >
            {/* {it?.name_task.length > 40 ?
                `${it?.name_task?.substring(0, 40)}...`
                :
                it?.name_task
            } */}
        </div>
    )
}